import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { translate } from 'react-translate';
import { Dropdown, Form, Label, Table } from 'semantic-ui-react';
import envList from '../../../constants/envList';
import ProductType from '../../../constants/ProductType';
import API from '../../../services/Api';
import StandardService from '../../../services/StandardService';
import { TechnicalInfoIcon } from '../../shared/TechnicalInfoIcon';
import UserService from '../../../services/userService';

class ComponentTableCP extends Component {
  static clickDownloadPdf(urlToOpen) {
    if (urlToOpen) {
      const windowRef = window.open(urlToOpen, '_blank');
      windowRef.focus();
    }
  }

  static propTypes = {
    isoValue: PropTypes.number,
    onConformitychange: PropTypes.func,
    onIsEnoughChange: PropTypes.func,
    onStandardTotalChange: PropTypes.func,
    onThermalChange: PropTypes.func,
    resValue: PropTypes.number,
    t: PropTypes.func,
  }

  constructor(props) {
    super(props);
    this.state = {
      size: window.innerWidth,
    };
    const { onConformitychange } = props;
    if (onConformitychange) onConformitychange(true);

    this.changeInsulator = this.changeInsulator.bind(this);
    this.changeSupport = this.changeSupport.bind(this);
  }

  componentDidMount() {
    const { resValue, isoValue } = this.props;

    Promise.all([
      API.getPreselect(resValue, true, 100),
      API.getProducts(),
    ]).then(([{ data: { preselect } }, res]) => {
      const {
        insulators,
        membranes,
        selectedInsulator,
        selectedMembrane,
        selectedAdhesive,
        selectedMastic,
      } = StandardService.getProducts(envList.CP.path, preselect, res, isoValue);

      const costs = StandardService.calculateCost([
        {
          type: ProductType.INSULATOR_BETWEEN,
          productData: selectedInsulator,
        },
        {
          type: ProductType.MEMBRANE,
          productData: selectedMembrane,
        },
        {
          type: ProductType.ADHESIVE,
          productData: selectedAdhesive,
        },
        {
          type: ProductType.MASTIC,
          productData: selectedMastic,
        },
      ], isoValue, envList.CP.path);

      const {
        insulatorBetween,
        membrane,
        adhesive,
        mastic,
      } = costs;

      this.setState(
        {
          insulators,
          membranes,
          selectedInsulator,
          selectedMembrane,
          selectedAdhesive,
          selectedMastic,
          ...membrane,
          ...adhesive,
          ...mastic,
          ...insulatorBetween,
        },
        () => {
          if (selectedInsulator) {
            this.calculateThermalvalue();
          }
          this.calculTotal();
        }
      );
    });
    window.addEventListener('resize', this.resize.bind(this));
  }

  resize = () => {
    this.setState({ size: window.innerWidth });
  }

  changeMembrane = (_, inputData) => {
    const { isoValue } = this.props;

    const { value: selected } = inputData;

    const costs = StandardService.calculateCost([
      {
        type: ProductType.MEMBRANE,
        productData: selected,
      },
    ], isoValue, envList.CP.path);

    this.setState({
      selectedMembrane: selected,
      ...costs.membrane,
    }, () => {
      this.calculTotal();
      this.checkConformity();
    });
  }

  changeSupport = (_, val, noFormat) => {
    const { supports, selectedSupport } = this.state;

    for (let i = 0; i < supports.length; i++) {
      if (supports[i].text === selectedSupport.name) {
        supports[i].value.price = val.value;
        supports[i].value.noFormat = noFormat;
      }
    }

    this.setState({
      supports,
      selectedSupport: {
        ...selectedSupport,
        price: val.value,
        noFormat,
      },
    }, this.calculateSupport);
  }

  changeAdhesif = (_, val, noFormat) => {
    const { adhesifsIME, selectedAdhesif, adhesifBox } = this.state;
    let cost = 0;

    selectedAdhesif.price = val.value;
    selectedAdhesif.noFormat = noFormat;

    for (let i = 0; i < adhesifsIME.length; i++) {
      if (adhesifsIME[i].key === selectedAdhesif.id) {
        adhesifsIME[i].value.price = val.value;
        adhesifsIME[i].value.noFormat = noFormat;
      }
    }

    cost = val.value * adhesifBox;

    this.setState({ adhesifCost: cost, adhesifsIME, selectedAdhesif }, this.calculTotal);
  }

  changeInsulator(_, val, noFormat) {
    const { insulators, selectedInsulator } = this.state;

    selectedInsulator.price = val.value;
    selectedInsulator.noFormat = noFormat;

    for (let i = 0; i < insulators.length; i++) {
      if (insulators[i].key === selectedInsulator.id) {
        insulators[i].value.price = val.value;
        insulators[i].value.noFormat = noFormat;
      }
    }

    this.setState({ insulators, selectedInsulator }, () => {
      this.calculateThermalvalue();
    });
  }

  checkConformity() {
    const {
      thermalValue,
      selectedInsulator,
    } = this.state;
    const { resValue } = this.props;
    const { onConformitychange, onIsEnoughChange } = this.props;

    const isEnough = resValue <= thermalValue;
    const isConform = selectedInsulator
      && (selectedInsulator.cpt === 'OUI' || selectedInsulator.cpt === '1');

    onConformitychange(isConform);
    onIsEnoughChange(isEnough);
  }

  calculTotal() {
    const {
      adhesifCost,
      costInsBet,
      costMem,
      masticCost,
    } = this.state;
    const { onStandardTotalChange } = this.props;

    onStandardTotalChange(
      costInsBet
      + costMem
      + adhesifCost
      + masticCost
    );
    this.checkConformity();
  }

  calculateThermalvalue() {
    const { onThermalChange } = this.props;
    const { selectedInsulator } = this.state;

    const thermalValue = (
      Number(
        selectedInsulator && selectedInsulator.resistance
      )
    ).toFixed(1);
    this.setState({ thermalValue }, this.checkConformity);
    onThermalChange(thermalValue);
  }

  render() {
    const { t } = this.props;
    const {
      adhesifBox,
      adhesifCost,
      costMem,
      insulators,
      masticBox,
      masticCost,
      membranes,
      nbRollMem,
      selectedAdhesive: selectedAdhesif,
      selectedInsulator,
      selectedMastic,
      selectedMembrane,
      size,
      usedAdhesif,
      usedMastic,
      usedMem,
      usedInsBet,
      nbRollInsBet,
      costInsBet,
    } = this.state;

    const token = sessionStorage.getItem('USER_TOKEN');

    return (
      <Table basic="very" className="tableStandard">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell />
            <Table.HeaderCell>
              {t('standard_table_title')}
            </Table.HeaderCell>
            <Table.HeaderCell />
            <Table.HeaderCell>
              {t('standard_table_title_quantity')}
            </Table.HeaderCell>
            <Table.HeaderCell>
              {t('standard_table_title_unité')}
            </Table.HeaderCell>
            <Table.HeaderCell>
              {t('standard_table_title_price_surface')}
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          <Table.Row>
            <Table.Cell>
              1.
            </Table.Cell>
            <Table.Cell className="cellTableStandard">
              {t('standard_table_insulator_between')}
              <TechnicalInfoIcon
                t={t}
                onClick={() => {
                  if (selectedInsulator) ComponentTableCP.clickDownloadPdf(selectedInsulator.link);
                }}
              />
              <br />
              <Dropdown
                search
                selection
                disabled
                options={insulators}
                value={selectedInsulator}
                onChange={(e, val) => this.changeSousChevrons(e, val)}
              />
            </Table.Cell>
            <Table.Cell className="cellTable">
              {(usedInsBet || 0).toFixed(2)}
              {' '}
              {t('standard_table_insulator_surface')}
            </Table.Cell>
            <Table.Cell className="cellTableQuantity">
              {(nbRollInsBet || 0).toFixed(2)}
              {' '}
              {t('standard_table_insulator_roll')}
            </Table.Cell>
            <Table.Cell className="cellTableStandard">
              <Form className="inputInTable">
                <Form.Input
                  type="number"
                  onClick={e => e.target.select()}
                  width={8}
                  step={0.10}
                  disabled={token === null || UserService.isUser()}
                  value={
                    selectedInsulator && selectedInsulator.noFormat
                      ? selectedInsulator && selectedInsulator.price
                      : Number(selectedInsulator && selectedInsulator.price).toFixed(2) || 0
                  }
                  onChange={(e, val) => this.changeInsulator(e, val, true)}
                  onBlur={
                    () => {
                      this.changeInsulator(
                        null,
                        { value: selectedInsulator && selectedInsulator.price },
                        false
                      );
                    }
                  }
                />
                <Label className={size <= 992 ? 'labelInFormTablette' : 'labelInForm'}>
                  {t('standard_table_insulator_price')}
                </Label>
              </Form>
            </Table.Cell>
            <Table.Cell className="cellTable">
              {(costInsBet || 0).toFixed(2)}
              {' '}
              {t('standard_table_insulator_price')}
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>
              2.
            </Table.Cell>
            <Table.Cell className="cellTableStandard">
              {t('standard_table_membrane_cp')}
              <TechnicalInfoIcon
                t={t}
                onClick={() => {
                  if (selectedMembrane) ComponentTableCP.clickDownloadPdf(selectedMembrane.link);
                }}
              />
              <br />
              <Dropdown
                search
                selection
                options={membranes}
                default={selectedMembrane}
                value={selectedMembrane}
                onChange={this.changeMembrane}
              />
            </Table.Cell>
            <Table.Cell className="cellTable">
              {(usedMem || 0).toFixed(2)}
              {' '}
              {t('standard_table_insulator_surface')}
            </Table.Cell>
            <Table.Cell className="cellTableQuantity">
              {(nbRollMem || 0).toFixed(2)}
              {' '}
              {t('standard_table_insulator_roll')}
            </Table.Cell>
            <Table.Cell className="cellTableStandard">
              <Form className="cellTableWithoutDropdown">
                <Form.Input
                  type="number"
                  onClick={e => e.target.select()}
                  width={8}
                  step={0.10}
                  disabled={token === null || UserService.isUser()}
                  value={
                    selectedMembrane && selectedMembrane.noFormat
                      ? selectedMembrane && selectedMembrane.price
                      : Number(selectedMembrane && selectedMembrane.price).toFixed(2)
                  }
                  onChange={(e, val) => this.changeAdhesif(e, val, true)}
                  onBlur={
                    () => this.changeAdhesif(
                      null,
                      { value: selectedMembrane && selectedMembrane.price },
                      false
                    )
                  }
                />
                <Label className={size <= 992 ? 'labelInFormTablette' : 'labelInForm'}>
                  {t('standard_table_membrane_price')}
                </Label>
              </Form>
            </Table.Cell>
            <Table.Cell className="cellTable">
              {(costMem || 0).toFixed(2)}
              {' '}
              {t('standard_table_membrane_price')}
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>
              3.
            </Table.Cell>
            <Table.Cell className="cellTableStandard">
              {t('CP_component_5')}
              <TechnicalInfoIcon
                t={t}
                onClick={() => {
                  if (selectedAdhesif) ComponentTableCP.clickDownloadPdf(selectedAdhesif.link);
                }}
              />
            </Table.Cell>
            <Table.Cell className="cellTable">
              {(usedAdhesif || 0).toFixed(2)}
              {' '}
              {t('standard_table_adhesif_surface')}
            </Table.Cell>
            <Table.Cell className="cellTableQuantity">
              {(adhesifBox || 0).toFixed(2)}
              {' '}
              {t('standard_table_insulator_roll')}
            </Table.Cell>
            <Table.Cell className="cellTableStandard">
              <Form className="cellTableWithoutDropdown">
                <Form.Input
                  type="number"
                  onClick={e => e.target.select()}
                  width={8}
                  step={0.10}
                  disabled={token === null || UserService.isUser()}
                  value={
                    selectedAdhesif && selectedAdhesif.noFormat
                      ? selectedAdhesif && selectedAdhesif.price
                      : Number(selectedAdhesif && selectedAdhesif.price).toFixed(2)
                  }
                  onChange={(e, val) => this.changeAdhesif(e, val, true)}
                  onBlur={
                    () => this.changeAdhesif(
                      null,
                      { value: selectedAdhesif && selectedAdhesif.price },
                      false
                    )
                  }
                />
                <Label className={size <= 992 ? 'labelInFormTablette' : 'labelInForm'}>
                  {t('standard_table_adhesif_price')}
                </Label>
              </Form>
            </Table.Cell>
            <Table.Cell className="cellTable">
              {(adhesifCost || 0).toFixed(2)}
              {' '}
              {t('standard_table_adhesif_price')}
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>
              4.
            </Table.Cell>
            <Table.Cell className="cellTableStandard">
              {t('CP_component_6')}
              <TechnicalInfoIcon
                t={t}
                onClick={() => {
                  if (selectedMastic) ComponentTableCP.clickDownloadPdf(selectedMastic.link);
                }}
              />
            </Table.Cell>
            <Table.Cell className="cellTable">
              {(usedMastic || 0).toFixed(2)}
              {' '}
              {t('standard_table_adhesif_surface')}
            </Table.Cell>
            <Table.Cell className="cellTableQuantity">
              {(masticBox || 0).toFixed(2)}
              {' '}
              {t('standard_table_mastic_cartouches')}
            </Table.Cell>
            <Table.Cell className="cellTableStandard">
              <Form className="cellTableWithoutDropdown">
                <Form.Input
                  type="number"
                  onClick={e => e.target.select()}
                  width={8}
                  step={0.10}
                  disabled={token === null || UserService.isUser()}
                  value={
                    selectedMastic && selectedMastic.noFormat
                      ? selectedMastic && selectedMastic.price
                      : Number(selectedMastic && selectedMastic.price).toFixed(2)
                  }
                  onChange={(e, val) => this.changeAdhesif(e, val, true)}
                  onBlur={
                    () => this.changeAdhesif(
                      null,
                      { value: selectedMastic && selectedMastic.price },
                      false
                    )
                  }
                />
                <Label className={size <= 992 ? 'labelInFormTablette' : 'labelInForm'}>
                  {t('standard_table_mastic_price')}
                </Label>
              </Form>
            </Table.Cell>
            <Table.Cell className="cellTable">
              {(masticCost || 0).toFixed(2)}
              {' '}
              {t('standard_table_mastic_price')}
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    );
  }
}

export default translate('StandardSoluceComponent')(ComponentTableCP);



// WEBPACK FOOTER //
// ./src/components/Protected/standard/componentTableCP.jsx